if (customElements.get('quick-add') === undefined) {
  class QuickAdd extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    serializeForm (form) {
      const obj = {};
      const formData = new FormData(form);
      for (const key of formData.keys()) obj[key] = formData.get(key);
      return JSON.stringify(obj);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      this.handleErrorMessage();

      this.submitButton = this.querySelector('[name="add"]');
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      this.fetchConfig = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }};
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      this.fetchConfig.body = JSON.stringify({
        ...JSON.parse(this.serializeForm(this.form)),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, this.fetchConfig)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { response } }));
        })
        .catch((error) => { console.error(error) })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
        }
      );
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.error-message');
      this.errorMessageContent = this.errorMessageContent || this.errorMessageWrapper.querySelector('.error-message--content');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessageContent.textContent = errorMessage;
    }
  }

  customElements.define('quick-add', QuickAdd);
}
